module.exports = __webpack_public_path__ + "static/media/screenshot_1.a66be90b.png";